import { render } from "./AvailableSurveys.vue?vue&type=template&id=dec29764"
import script from "./AvailableSurveys.vue?vue&type=script&lang=js"
export * from "./AvailableSurveys.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__